import React from 'react';
import PropTypes from 'prop-types';
import { Button, CircularProgress } from '@material-ui/core';
import { useLoadingButtonStyles } from './styles';

const LoadingButton = ({ ...props }) => {
  const {
    loading,
    color,
    variant,
    disabled,
    text,
    className,
    name,
    onClick,
  } = props;

  const classes = useLoadingButtonStyles();

  return (
    <div className={classes.wrapper}>
      <Button
        data-cy={`loadingButton${name}`}
        color={color}
        variant={variant}
        disabled={disabled || loading}
        onClick={onClick}
        className={className}
      >
        {text}
      </Button>
      {loading && (
        <CircularProgress size={24} className={classes.buttonProgress} />
      )}
    </div>
  );
};

LoadingButton.propTypes = {
  loading: PropTypes.bool,
  color: PropTypes.string,
  variant: PropTypes.string,
  disabled: PropTypes.bool,
  text: PropTypes.string,
  className: PropTypes.string,
  name: PropTypes.string,
  onClick: PropTypes.func,
};

export default LoadingButton;
